import * as React from 'react';
import { FormComponentProps } from 'antd/lib/form';
import { RouteComponentProps, withRouter } from 'react-router';
import { Form, Row, Col, Input, Icon, Select, Button, Checkbox, Collapse, Tooltip, Switch } from 'antd';
import FormControl from 'components/Forms/FormControl';
import FormUtility from 'Core/FormUtility';
import ValidationUtility from 'Core/ValidationUtility';
import MaskedInput from 'components/Forms/MaskedInput';
import { CreditCardRegistrationFormHandler } from 'components/UserManagement/Profile/CreditCardRegistrationForm/CreditCardRegistrationFormHandler';
import {
  IReferenceValueDto,
  CreditCardRegistrationDto,
  ExecuteBillOfLadingPaymentRequest,
  CreditCardPaymentMethodDto,
  BillOfLadingDto,
  BillOfLadingChargeDto,
  BillOfLadingData,
  BeginBillPaymentRequest,
  ICreditCardRegistrationDto,
  ICreditCardPaymentMethodDto,
  CreditCardDetailsDto,
  AddressDto
} from 'Core/Api/Payment/Api';
import {
  PageContainerRow,
  PageContainerCol,
  PageContainerColLayout,
} from 'components/CartManagement/CartOverviewView/CartOverviewView.Style';
import { PageTitle } from 'components/Styled/Layout.Styled';
import CheckoutFooter from './CheckoutFooter';
import CheckoutCardImage from '../../../assets/images/creditcardcheckout.png';
import VerifiedByImage from '../../../assets/images/vbv_mcsc_logo.png';
import { AuthUser } from 'Core/models/AuthUser';
import CartContext from 'Context/CartContext';
import moment from 'moment';
import { CargoChargesHandler } from 'components/CargoCharges/CargoChargesForm/CargoChargesFormHandler';
import { CargesModel } from 'components/CargoCharges/CargoChargesResults/CargoChargesResultsModel';
import { CheckoutHandler } from './CheckoutHandler';
import TermsAndConditionLink from 'components/Forms/TermsAndConditionLink';
import Utility from 'Core/Utility';
import { LOGROCKET_IGNORE_CLASS } from 'components/LogRocketErrorMonitor/LogRocketErrorMonitor';
import { CardSelectForm } from './CardSelectForm';
import { SelectedCard, CardSelectFormWithoutRouterAndForm } from './CardSelectForm/CardSelectForm';
import NotificationUtility from 'Core/NotificationUtility';
import ShowIfTrue from 'components/Forms/ShowIfTrue';
import { SubmitButton } from 'components/SubmitButton';
import CenteredPageContainer from "components/Layout/CenteredPageContainer";
import styled from 'styled-components';

export interface Props extends FormComponentProps, RouteComponentProps {
  children?: React.ReactNode;
  user?: AuthUser;
}

export interface State {
  cardTypes: IReferenceValueDto[];
  cardCurrencies: IReferenceValueDto[];
  confirmedCard?: ICreditCardRegistrationDto[];
  bols?: BillOfLadingDto[];
  gotAllInfo: boolean;
  cardRetry: number;
  cardTypeRetry: number;
  bolRetry: number;
  usingSavedCard: boolean;
  slectedCard?: SelectedCard;
  selectCardFormUpdateHack: number;
  currentTabKey?: string;
  paymentRequest?: any;
}

class CheckoutFormWithoutRouterAndForm extends React.Component<Props, State> {
  static contextType = CartContext;
  context!: React.ContextType<typeof CartContext>;
  creditCardRegistrationFormHandler: CreditCardRegistrationFormHandler;
  cargoChargesHandler: CargoChargesHandler;
  checkoutHandler: CheckoutHandler;
  cardSelectFormRef;

  constructor(props: Props) {
    super(props);
    this.creditCardRegistrationFormHandler = new CreditCardRegistrationFormHandler(props);
    this.checkoutHandler = new CheckoutHandler(props);
    this.cargoChargesHandler = new CargoChargesHandler(props);
    this.getRegisteredCards = this.getRegisteredCards.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);

    this.state = {
      cardTypes: [],
      cardCurrencies: [],
      bols: [],
      gotAllInfo: false,
      cardRetry: 0,
      cardTypeRetry: 0,
      bolRetry: 0,
      usingSavedCard: true,
      selectCardFormUpdateHack: 1,
      currentTabKey: "1"
    };
  }

  componentDidMount() {
    this.getCardType();
    this.getRegisteredCards();
    this.getBolInfo();

  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.paymentRequest != this.state.paymentRequest) {
      this.props.history.push("/payment-processing", this.state.paymentRequest);
    }
  }

  getBolInfo() {
    this.context.data?.cartItems?.forEach(x => {
      const date = moment.parseZone(x.pickupDate);
      const bolNumber = x.itemReference;

      Utility.retry(this.cargoChargesHandler
        .GetRawBillOfLadingCharges({ bolNumber: bolNumber!, storageToDate: date }),
        3,
        500)
        .then(y => {

          // find related cart item because might have to take storageToDate from it.
          const cartItem = this.context.data?.cartItems?.filter(x => x.itemReference === bolNumber)[0];

          // Transaform to BillOfLadingDto
          const bol: BillOfLadingDto = new BillOfLadingDto({
            bolNumber: bolNumber!,
            bolData: new BillOfLadingData({ bolReferenceNumbers: y.bolReferenceNos!, bolStorageToDate: x.pickupDate || cartItem?.pickupDate! }),
            charges: y.data!.map((charge: CargesModel) => {
              return new BillOfLadingChargeDto({
                chargeName: charge.chargeType!,
                amount: charge.chargeAmount!
              });

            })

          });
          this.setState({ bols: [...this.state.bols ?? [], bol] });
        }).catch(error => {
          NotificationUtility.error("Please Refresh", "An error occurred while retriving important information. Please refresh this page and try again.");
        })

    })
  }

  getRegisteredCards() {
    if (this.props.user?.id) {
      Utility.retry(this.creditCardRegistrationFormHandler
        .GetRegisteredCreditCard(this.props.user.id), 3, 500)
        .then(x => {
          const confirmedCard = x.filter(card => card.isConfirmed);
          this.setState({ confirmedCard });
        }).catch(x => { });
    }
  }

  getCardType() {
    const repeatableCreditCardTypes = Utility.retry(this.creditCardRegistrationFormHandler
      .GetCreditCardTypes(), 3, 500);
    repeatableCreditCardTypes
      .then(type => {
        if (type !== undefined) {
          this.setState({ cardTypes: type });
        }
      });
  }

  CardOptionsChanged = (option) => {
    this.setState({ usingSavedCard: option == "1", currentTabKey: option })
  }

  SelectedCardDetailsChanged = (slectedCard: SelectedCard) => {
    this.setState({ slectedCard });
  }

  onFormSubmit(event: React.FormEvent) {
    event.preventDefault();


    if (this.state.usingSavedCard) {
      this.submitSavedCardDetailsForm();
    } else {
      this.submitCardDetailsForm();
    }

  }

  submitSavedCardDetailsForm = () => {


    var selectedCard = this.state.slectedCard;

    // console.log(selectedCard);

    if (!selectedCard || !selectedCard?.card || !selectedCard?.cvv || !selectedCard?.isAuthorize) {
      // This hack it to force the selectCardForm to up on a on demand
      // The componentDidUpdate will be called and action will be taken in it.
      // Ref did not work because SelectCardForm is a HOC and FrowardRef did not work.
      this.setState({ selectCardFormUpdateHack: this.state.selectCardFormUpdateHack + 1 })
      return;
    }

    // Find registered card for billing information
    let paymentMethod = new CreditCardPaymentMethodDto();
    paymentMethod.paymentCardId = selectedCard?.card.id as any;
    let cardDetails = {
      cardNumber: `${selectedCard.card.cardNumberFirstFourDigits}XXXXXXXX${selectedCard.card.cardNumberLastFourDigits}`,
      cardCurrencyCode: selectedCard.card.cardCurrencyCode,
      cardName: selectedCard.card.cardName,
      expiryYear: moment().add(3, "y").year().toString(),
      expiryMonth: "12",
      cardTypeId: selectedCard.card.cardTypeId,
      expiry: '2020/20',
      cvv: selectedCard.cvv,
      billingAddress: new AddressDto(selectedCard?.card!.billingAddress!)
    };

    paymentMethod.cardDetails = new CreditCardDetailsDto(cardDetails);

    const request: BeginBillPaymentRequest = new BeginBillPaymentRequest();
    request.paymentMethod = paymentMethod;
    request.billOfLadings = this.state.bols;
    request.currencyCode = "JMD";
    request.jmdExchangeRate = 1;
    request.total = Number.parseFloat(this.context.data?.total!.toFixed(2) ?? "0");
    request.totalInJmd = Number.parseFloat(this.context.data?.total!.toFixed(2) ?? "0");
    request.userEmailAddress = this.props.user?.email!;
    request.userId = this.props.user?.id!;
    request.userMobilePhone = "<>";

    this.setState({ paymentRequest: request });

  }

  submitCardDetailsForm = () => {

    this.props.form.validateFieldsAndScroll(
      (error, values: ICreditCardPaymentMethodDto) => {

        // find related card for registration
        values.cardDetails!.cardNumber = values.cardDetails!.cardNumber?.split(" ").join("");
        const cardFirstFourDigits = values.cardDetails!.cardNumber?.substr(0, 4);
        const cardLastFourDigits = values.cardDetails!.cardNumber?.substr(12, 4);
        const card = this.state.confirmedCard?.
          filter(card => card.cardNumberFirstFourDigits === cardFirstFourDigits &&
            card.cardNumberLastFourDigits === cardLastFourDigits)[0];
        if (!card) {
          this.ShowCardRegistartionError();
          return;
        }

        if (!error) {
          // set expiry month & year
          if (values.cardDetails !== undefined) {
            const expiryParts = FormUtility.getExpiryDateParts(values.cardDetails.expiry);
            values.cardDetails.expiryMonth = expiryParts?.month!;
            values.cardDetails.expiryYear = expiryParts?.year!;
          }

          // Find registered card for billing information
          values.cardDetails!.billingAddress = card?.billingAddress!;
          values.cardDetails!.cardCurrencyCode = card?.cardCurrencyCode!;

          const request: BeginBillPaymentRequest = new BeginBillPaymentRequest();
          request.paymentMethod = new CreditCardPaymentMethodDto(values);
          request.billOfLadings = this.state.bols;
          request.currencyCode = "JMD";
          request.jmdExchangeRate = 1;
          request.total = Number.parseFloat(this.context.data?.total!.toFixed(2) ?? "0");
          request.totalInJmd = Number.parseFloat(this.context.data?.total!.toFixed(2) ?? "0");
          request.userEmailAddress = this.props.user?.email!;
          request.userId = this.props.user?.id!;
          request.userMobilePhone = "<>";
          request.shouldTokenize = values["saveTokenizeCard"] ?? false;

          const callback = this.props.history.listen((l, a) => {
          });

          setTimeout(callback, 1000);

          this.props.history.replace("/payment-processing", request);
        }
      });

  }


  render() {
    const { form } = this.props;
    const getFieldDecorator = form.getFieldDecorator;
    const { Option } = Select;

    const cardTypeSelector = (
      <Select showSearch allowClear={true}>
        {this.state.cardTypes.map(type => (
          <Option key={type.id} value={type.id}>{type.description}</Option>
        ))}
      </Select>
    );

    const CustomCheckbox = styled(Checkbox) <{ backgroundColor: any }>`
      ${props =>
        props.backgroundColor && `
          & .ant-checkbox .ant-checkbox-inner {
            background-color: ${props.backgroundColor};
          }
        `}
    `;

    return (
      <CenteredPageContainer title="Checkout">
        <PageContainerRow style={{ textAlign: 'center' }}>
          {/* <PageTitle title="Checkout" /> */}
          <PageContainerCol> {/* <PageContainerCol {...PageContainerColLayout}> */}
            {/* <Form onSubmit={this.onFormSubmit} layout='vertical'> */}
            <Form layout="vertical"
              className={LOGROCKET_IGNORE_CLASS}
              onSubmit={this.onFormSubmit} >
              <Row type="flex" justify="center" >
                <Col span={15} pull={1} >
                  <img src={CheckoutCardImage} style={{ width: "70%" }} alt="" />
                </Col>
              </Row>
              <p> <br /> </p>
              <Row>
                <Col>
                  <Collapse onChange={this.CardOptionsChanged} bordered={true} accordion={true} defaultActiveKey="1"  >
                    <Collapse.Panel style={{ backgroundColor: '#f8f8f8' }} header={<h3>Select A Saved Card</h3>} key="1" >
                      <CardSelectForm updateHack={this.state.selectCardFormUpdateHack} onCardDetailsChanged={this.SelectedCardDetailsChanged} confirmedCards={this.state.confirmedCard} />
                    </Collapse.Panel>

                    <Collapse.Panel header={""} style={{ backgroundColor: '#ffffff' }} showArrow={false} disabled key="2">
                    </Collapse.Panel>

                    <Collapse.Panel style={{ backgroundColor: '#f8f8f8' }} header={<h3>Enter Card Details</h3>} key="3" >
                      <Row>
                        <Col>
                          <Row>
                            <Col pull={7}>

                            </Col>

                            <Col push={3}>
                              <Row gutter={15} type="flex" align="middle">
                                {/* Name on Card */}
                                <Col
                                  xs={{ span: 20 }}
                                  sm={{ span: 20 }}
                                  md={{ span: 10 }}
                                  lg={{ span: 10 }}
                                  xl={{ span: 10 }}>
                                  <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    rules={[...ValidationUtility.getRequired('Please enter your Card Name'),
                                    // eslint-disable-next-line no-useless-escape
                                    ...ValidationUtility.getPattern(/^\D*$/, 'Please enter a non-numeric value')
                                    ]}
                                    name="cardDetails.cardName"
                                    label="Name on Card">
                                    <Input
                                      prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                      placeholder="Name of Cardholder"
                                    />
                                  </FormControl>
                                </Col>

                                {/* Save Card */}
                                <Col
                                  xs={{ span: 5 }}
                                  sm={{ span: 5 }}
                                  md={{ span: 7 }}
                                  lg={{ span: 7 }}
                                  xl={{ span: 7 }}>
                                  <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    name="saveTokenizeCard"
                                    label={<Tooltip title="Saving card information will allow you to select a registered card at checkout instead of filling in the information again. You will still need to enter the CVV.">Save Card for faster Checkout&nbsp;<Icon type="info-circle" /></Tooltip>}
                                    valuePropName="checked">

                                    <CustomCheckbox backgroundColor="#a1a1a1">
                                    </CustomCheckbox>

                                  </FormControl>
                                </Col>
                              </Row>

                              <Row type="flex" align="top" gutter={10}>
                                {/* Card Number */}
                                <Col
                                  xs={{ span: 20 }}
                                  sm={{ span: 20 }}
                                  md={{ span: 8 }}
                                  lg={{ span: 8 }}
                                  xl={{ span: 8 }}>
                                  <FormControl
                                    getFieldDecorator={getFieldDecorator}

                                    rules={
                                      [...ValidationUtility.getCardNumberTransform(),
                                      ...ValidationUtility.getRequired('Please enter Card Number'),
                                      ...ValidationUtility.getCreditCardNumber(
                                        this.props.form,
                                        'cardDetails.cardTypeId'
                                      ),

                                      ...ValidationUtility.getPattern(
                                        /[0-9]{4}[0-9]{4}[0-9]{4}/,
                                        'Please enter valid Credit Card Number'
                                      ),
                                      ]}
                                    name="cardDetails.cardNumber"
                                    label="Card Number">
                                    <MaskedInput
                                      prefix={<Icon type="credit-card" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                      mask="9999 9999 9999 9999"
                                      alwaysShowMask={true}
                                      placeholder="Card Number"
                                    />
                                  </FormControl>
                                </Col>

                                {/* Credit Card Type*/}
                                <Col
                                  xs={{ span: 20 }}
                                  sm={{ span: 20 }}
                                  md={{ span: 7 }}
                                  lg={{ span: 7 }}
                                  xl={{ span: 7 }}>
                                  <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    rules={[
                                      ...ValidationUtility.getRequired('Please select a Credit Card Type'),
                                      ...ValidationUtility.validateOtherFields(form, 'cardDetails.cardNumber'),
                                    ]}
                                    name="cardDetails.cardTypeId"
                                    label="Credit Card Type"
                                  // initialValue='Visa'
                                  >
                                    {cardTypeSelector}
                                  </FormControl>
                                </Col>
                              </Row>

                              <Row gutter={10} align='bottom' type='flex'>
                                {/* Expiry Date */}
                                <Col
                                  xs={{ span: 20 }}
                                  sm={{ span: 20 }}
                                  md={{ span: 5 }}
                                  lg={{ span: 5 }}
                                  xl={{ span: 5 }}>
                                  <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    rules={[
                                      ...ValidationUtility.getRequired('Please enter Card expiry date'),
                                      ...ValidationUtility.getIsValidExpiryDate(),
                                    ]}
                                    name="cardDetails.expiry"
                                    label="Expiry Date (MM/YY)">
                                    <MaskedInput
                                      prefix={<Icon type="card" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                      mask="99/99"
                                      alwaysShowMask={true}
                                      className="Sumperess"
                                      placeholder="Card Number"
                                    />
                                  </FormControl>
                                </Col>

                                {/* CVV2/CVCV2 */}
                                <Col
                                  xs={{ span: 20 }}
                                  sm={{ span: 20 }}
                                  md={{ span: 5 }}
                                  lg={{ span: 5 }}
                                  xl={{ span: 5 }}>
                                  <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    rules={[
                                      ...ValidationUtility.getRequired('Please enter CVV2 Number'),
                                      ...ValidationUtility.getPattern(
                                        /^[0-9]{3}/,
                                        'Please enter valid  CVV2 Number'
                                      ),
                                    ]}
                                    name="cardDetails.cvv"
                                    label="CVV2/CVC2">
                                    <MaskedInput
                                      prefix={<Icon type="card" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                      mask="999"
                                      placeholder="CVV2/CVC2"
                                      type="password" />
                                  </FormControl>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row>
                            <Col  xs={{ span: 20 }}
                                sm={{ span: 20 }}
                                md={{ span: 12,offset:3 }}
                                lg={{ span: 12,offset:3 }}
                                xl={{ span: 12,offset:3 }}>
                              <FormControl
                                getFieldDecorator={getFieldDecorator}
                                name="termsCon"
                                valuePropName="checked"
                                initialValue={false}
                                rules={[
                                  ...ValidationUtility.getCheckBoxChecked(
                                    'Please confirm that you are authorised to use this card'
                                  ),
                                  // ...ValidationUtility.getRequired('Please confirm that you are authorised to use this card')
                                ]}>
                                <Checkbox> I confirm that I am authorized to use this card.</Checkbox>
                              </FormControl>
                            </Col>
                          </Row>
                        </Col>

                      </Row>
                    </Collapse.Panel>
                  </Collapse>
                </Col>
              </Row>

              <Row>
                <Col>
                  <ShowIfTrue condition={!!this.state.bols?.length && !!this.state.confirmedCard?.length}>
                    <SubmitButton
                      type="default"
                      htmlType="submit"
                      className="login-form-button"
                      style={{ width: '100%', backgroundColor: "#77DD2E", color: "white" }}>
                      <CheckoutFooter />
                    </SubmitButton>
                  </ShowIfTrue>
                  <ShowIfTrue condition={!(!!this.state.bols?.length && !!this.state.confirmedCard?.length)}>
                    <SubmitButton
                      type="default"
                      htmlType="submit"
                      className="login-form-button"
                      disabled={true}
                      style={{ width: '100%', backgroundColor: "#77DD2E", color: "white" }}>
                      <CheckoutFooter />
                    </SubmitButton>
                  </ShowIfTrue>
                </Col>
              </Row>

              <Row type="flex" justify="center" >
                <Col span={7}>
                  <img style={{ width: "100%" }} src={VerifiedByImage} alt="" />
                </Col>
              </Row>

              <Row type="flex" justify="center">
                <Col span={12}>
                  <p>Your card may be eligible or enrolled in Verified by Visa or MasterCard SecureCode Consumer Authentication programs. After clicking the 'Checkout' button, your Card Issuer may prompt you for your Consumer Authentication password to complete your purchase.</p>
                  <p>By checking out you are agreeing to the Kingston Wharves <TermsAndConditionLink />.</p>
                </Col>
              </Row>

            </Form>


          </PageContainerCol>
        </PageContainerRow >
      </CenteredPageContainer>
    );
  }

  private ShowCardRegistartionError() {
    this.props.form.setFields({ "cardDetails.cardNumber": { errors: [new Error("Can only use cards that have been registered and confirmed")] } });
  }

}

const CheckoutWithoutRouter = Form.create<Props>({
  name: 'Checkout',
})(CheckoutFormWithoutRouterAndForm);

const CheckoutForm = withRouter(CheckoutWithoutRouter);

export default CheckoutForm;
